import {DataChunk, DataPoint, DataPointParams, DimensionItem} from '@selpia/shared/models';

import {DateTools} from './date-tools';
import {ArrayTools} from './array-tools';

export class DataBatchTools {
  static getDataPointFor(
    dataPoints: DataPoint[],
    {
      measureCode,
      periodCode,
      date,
    }: DataPointParams,
  ): DataPoint | undefined {
    if (!measureCode || !periodCode || !date) {
      return;
    }

    return dataPoints.find(
      (dataPoint) =>
        dataPoint.periodCode === periodCode &&
        dataPoint.measureCode === measureCode &&
        DateTools.match(dataPoint.date, date),
    );
  }

  static filterDataPoint(dataPoint: DataPoint, {measureCode, periodCode, date}: Partial<DataPointParams>): boolean {
    return ((periodCode ? periodCode === dataPoint.periodCode : true) &&
      (measureCode ? dataPoint.measureCode === measureCode : true) &&
      (date ? DateTools.match(dataPoint.date, date) : true));
  }

  static findDimensionItemBy = (
    {dimensionLevelName}: { dimensionLevelName: string },
    dimensionItems: DimensionItem[],
  ): DimensionItem | undefined =>
    dimensionItems.find((dimensionItem) => dimensionItem.dimensionLevelName === dimensionLevelName);

  static compareDataChunksValues(
    a: DataChunk,
    b: DataChunk,
    measureCode: string | null | undefined,
    periodCode: string | null | undefined,
    date: Date | null | undefined,
  ): number {
    if (!measureCode || !periodCode || !date) {
      return 0;
    }

    const aValue = this.getDataPointFor(a.dataPoints, {measureCode, periodCode, date})?.value;
    const bValue = this.getDataPointFor(b.dataPoints, {measureCode, periodCode, date})?.value;

    if (aValue === bValue) {
      return 0;
    }

    if (aValue === undefined) {
      return -1;
    }

    if (bValue === undefined) {
      return 1;
    }

    return aValue - bValue;
  }

  static getMinMax(dataChunks: DataChunk[], {measureCode, periodCode, date}: Partial<DataPointParams>): {
    min: number,
    max: number
  } {
    const points = ArrayTools.removeFalsy(
      dataChunks.map(dataChunk => dataChunk.dataPoints.find(dataPoint => DataBatchTools.filterDataPoint(dataPoint, {
        date,
        periodCode,
        measureCode,
      }))?.value));

    return {min: Math.min(...points, 0), max: Math.max(...points, 0)};
  }
}
